import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import AppLayout from "./components/layout/AppLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import InquiryPage from "./pages/InquiryPage";
import QuotationListPage from "./pages/QuotationListPage";
import QuotationCreatePage from "./pages/QuotationCreatePage";
import QuotationDetailPage from "./pages/QuotationDetailPage";
import OrderListPage from "./pages/OrderListPage";
import OrderCreatePage from "./pages/OrderCreatePage";
import OrderDetailPage from "./pages/OrderDetailPage";
import ApprovalInboxPage from "./pages/ApprovalInboxPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminRolesPage from "./pages/AdminRolesPage";
import AdminAuditPage from "./pages/AdminAuditPage";
import AdminSapPage from "./pages/AdminSapPage";
import CustomerListPage from "./pages/CustomerListPage";
import NotificationsPage from "./pages/NotificationsPage";
import SettingsPage from "./pages/SettingsPage";
import ScaffoldPage from "./pages/ScaffoldPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-sm text-gray-500">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-center">
          <div className="text-2xl font-black tracking-tighter text-[#0052CC] mb-2" style={{ fontFamily: "Chivo, sans-serif" }}>
            ARCHON
          </div>
          <div className="text-sm text-gray-500">Loading system...</div>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/inquiry" element={<ProtectedRoute><InquiryPage /></ProtectedRoute>} />
      <Route path="/quotations" element={<ProtectedRoute><QuotationListPage /></ProtectedRoute>} />
      <Route path="/quotations/new" element={<ProtectedRoute><QuotationCreatePage /></ProtectedRoute>} />
      <Route path="/quotations/:id" element={<ProtectedRoute><QuotationDetailPage /></ProtectedRoute>} />
      <Route path="/quotations/:id/edit" element={<ProtectedRoute><QuotationCreatePage /></ProtectedRoute>} />
      <Route path="/orders" element={<ProtectedRoute><OrderListPage /></ProtectedRoute>} />
      <Route path="/orders/new" element={<ProtectedRoute><OrderCreatePage /></ProtectedRoute>} />
      <Route path="/orders/:id" element={<ProtectedRoute><OrderDetailPage /></ProtectedRoute>} />
      <Route path="/orders/:id/edit" element={<ProtectedRoute><OrderCreatePage /></ProtectedRoute>} />
      <Route path="/approvals" element={<ProtectedRoute><ApprovalInboxPage /></ProtectedRoute>} />
      <Route path="/customers" element={<ProtectedRoute><CustomerListPage /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute><AdminUsersPage /></ProtectedRoute>} />
      <Route path="/admin/roles" element={<ProtectedRoute><AdminRolesPage /></ProtectedRoute>} />
      <Route path="/admin/audit" element={<ProtectedRoute><AdminAuditPage /></ProtectedRoute>} />
      <Route path="/admin/sap" element={<ProtectedRoute><AdminSapPage /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/delivery" element={<ProtectedRoute><ScaffoldPage title="Delivery" description="Delivery management module — scaffolded for future phases." /></ProtectedRoute>} />
      <Route path="/returns" element={<ProtectedRoute><ScaffoldPage title="Sales Return" description="Sales return management — scaffolded for future phases." /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
